// Constants used by Checkout.jsx — payment + delivery method lists,
// empty-address-form template, and the address-line formatter.

export const PAYMENT_METHODS = [
  { id: "mtn",        label: "MTN Mobile Money", icon: "smartphone",  hint: "USSD prompt on your phone" },
  { id: "airtel",     label: "Airtel Money",     icon: "smartphone",  hint: "USSD prompt on your phone" },
  { id: "visa",       label: "Visa",             icon: "credit-card", hint: "Secure card checkout" },
  { id: "mastercard", label: "Mastercard",       icon: "credit-card", hint: "Secure card checkout" },
];

export const DELIVERY_METHODS = [
  { id: "courier", label: "Courier delivery", hint: "To your address" },
  { id: "pickup",  label: "Pickup in store",  hint: "From seller" },
  { id: "self",    label: "Self arranged",    hint: "Coordinate with seller" },
];

export const EMPTY_ADDR_FORM = {
  label:           "",
  recipient_name:  "",
  phone:           "",
  street_address:  "",
  city:            "",
};

/** "John Doe · 4 Acacia Rd, Lusaka" — for the saved-address radio rows. */
export function addressHint(a) {
  const parts = [a.street_address, a.city].filter(Boolean);
  const line = parts.join(", ");
  return a.recipient_name ? `${a.recipient_name} · ${line}` : line;
}
